import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';


const Frame = ({ children, big, small, file, hover, className, onClick,...rest }) => (
    <i className={cx('icon', { 'icon--big': big, 'icon--small': small, 'icon--file': file, 'icon--hover': hover, }, className)} onClick={onClick} {...rest}>
        {children}
    </i>
);
Frame.propTypes = {
    hover: PropTypes.bool,
    big: PropTypes.bool,
    small: PropTypes.bool,
    file: PropTypes.bool,
    onClick: PropTypes.func
};
Frame.defaultProps = {
    hover: false,
    big: false,
    small: false,
    file: false,
    onClick: () => {}
};
const Icon = (props) => {
    const { name } = props;
    const capitalized = name.extensions.capitalize();
    const icoPromise = import(`./${capitalized}` /* webpackChunkName: "Ico_[request]" */);
    const Ico = React.lazy(() => icoPromise);
    return (
        <React.Suspense fallback={<Frame {...props} />}>
            <Frame {...props}>
                <Ico />
            </Frame>
        </React.Suspense>
    );
};
Icon.propTypes = {
    name: PropTypes.string.isRequired,
    big: PropTypes.bool,
    small: PropTypes.bool,
    file: PropTypes.bool,
    onClick: PropTypes.func
};
Icon.defaultProps = {
    big: false,
    small: false,
    file: false,
    onClick: () => {}
};
export default Icon;
